import { Placeholder } from "@angular/compiler/src/i18n/i18n_ast";
import { IRotatingWords } from "../interface/rotating-words";
export function processContent(raw: string, rotatingWordsGroupsData: any[], fontsize? : string): string {
  if (!rotatingWordsGroupsData) {
    return raw; // Return non-changed text if no rotating word groups
  }

  class rotatingWord implements IRotatingWords {
    placeholder: string = '';
    words: string = '';
    fontSize: string = '';
    fontColor: string = '';
    fontWeight: string = '';
    onItsOwnLine: boolean = false;

    constructor(props: any[]) {
      props.forEach(prop => {
        const { alias, value } = prop;
        if (alias in this) {
          (this as any)[alias] = value;
        }
      });
    }

    rwStyle() {
      return [
        this.fontSize ? `font-size: ${this.fontSize}px;` : '',
        this.fontColor ? `color: ${this.fontColor};` : '',
        this.fontWeight ? `font-weight: ${this.fontWeight};` : ''
      ].filter(Boolean).join(' ');
    }
  }

  let updatedContent = raw;

  rotatingWordsGroupsData.forEach((group: any, index: number) => {
    const props = group.properties || [];
    const rotatingWordItem = new rotatingWord(props);

    const words = rotatingWordItem.words.split(',');
    const placeholder = rotatingWordItem.placeholder;

    if (!placeholder || !words.length) return raw;

    const longestWord = words.reduce((a, b) => a.length > b.length ? a : b);
    const width = getContainerWidth(longestWord, rotatingWordItem);

    const styleParts = [
      'display:inline-block;',
      width,
      rotatingWordItem.rwStyle()
    ]

    const placeholderRegex = new RegExp('{{\\s*' + placeholder + '\\s*}}', 'g');
    const span = `<span class="rotating-word" data-placeholder="${placeholder}" style="${styleParts.filter(Boolean).join(' ')}">${words[0]}</span>`;

    updatedContent = updatedContent.replace(placeholderRegex, span);

    let currentIndex = 0;
    setInterval(() => {
      currentIndex = (currentIndex + 1) % words.length;
      const els = document.querySelectorAll(`.rotating-word[data-placeholder="${placeholder}"]`);
      els.forEach(el => {
        el.textContent = words[currentIndex];
      });
    }, 2000 + (index * 200));
  });

  return updatedContent;

  function getContainerWidth(word: string, item: rotatingWord) {
    if (item.onItsOwnLine == true) return 'width: 100%;';

    const size = item.fontSize ? item.fontSize + 'px' : fontsize;
    if (!size) return '';

    const font = `${size} Raleway`;
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    if (!context) return '';

    context.font = font;
    const wordLength = context.measureText(word).width;
    return wordLength ? `width: ${Math.ceil(wordLength)}px;` : '';
  }

}
